import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { Provider as StoreProvider } from 'react-redux';

import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/react';

import { store } from 'state';

import { App } from 'components/App';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: 'webviewer',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0
});

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
